module.exports = __webpack_public_path__ + "img/room1.d1bac12e.png";